import React from "react";

import { HealthSummary } from "../Shared";

interface BodyTemperatureData {
  date: string;
  value: number;
  hour?: number;
  datetime?: string;
}

interface HourlyBodyTemperatureData {
  datetime: string;
  value: number;
}

interface BodyTemperatureSummaryProps {
  filteredData: (BodyTemperatureData | HourlyBodyTemperatureData)[];
  metadata: {
    avg: number;
    min: number;
    max: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const BodyTemperatureSummary: React.FC<BodyTemperatureSummaryProps> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
  const getSummaryValues = (
    metadata: { avg: number; min: number; max: number } | null,
    _filteredData: (BodyTemperatureData | HourlyBodyTemperatureData)[],
  ) => [
    {
      label: "Min",
      value: Number(((metadata?.min ?? 0) / 10).toFixed(2)), // Convert from tenths to degrees and format to 2 decimal places
      color: "#3b82f6", // blue-500
      unit: "°F",
    },
    {
      label: "Avg",
      value: Number(((metadata?.avg ?? 0) / 10).toFixed(2)), // Convert from tenths to degrees and format to 2 decimal places
      color: "#22c55e", // green-500
      unit: "°F",
    },
    {
      label: "Max",
      value: Number(((metadata?.max ?? 0) / 10).toFixed(2)), // Convert from tenths to degrees and format to 2 decimal places
      color: "#ef4444", // red-500
      unit: "°F",
    },
  ];

  return (
    <HealthSummary
      filteredData={filteredData}
      metadata={metadata}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
      onDateSelect={onDateSelect}
      selectedDate={selectedDate}
      selectedRange={selectedRange}
      getSummaryValues={getSummaryValues}
    />
  );
};
